import React from 'react';
import PropTypes from 'prop-types';

import Icon from '../../component-library/icon';

const AiButtonRate = ({
	action,
	active,
	rateType,
	disabled,
}) => (
	<button
		type="button"
		className={`ignite-ai__button-rating align-self-${rateType === 'up' ? 'start' : 'end'} ${active && 'is-active'}`}
		title={`Thumbs ${rateType}!`}
		onClick={() => action(rateType)}
		disabled={disabled}
	>
		{rateType === 'up' ? (
			<Icon icon="thumbs-up" classes="ignite-ai__thumbs-up-icon" />
		) : (
			<Icon icon="thumbs-down" classes="ignite-ai__thumbs-down-icon" />
		)}
	</button>
);

export default AiButtonRate;

AiButtonRate.propTypes = {
	action: PropTypes.func.isRequired,
	rateType: PropTypes.string.isRequired,
	active: PropTypes.bool.isRequired,
	disabled: PropTypes.bool.isRequired,
};
